import * as angular from 'angular';
import { CellularDeviceSelectorComponent } from './CellularDeviceSelectorComponent';
import { CellularDeviceSelectorController } from './CellularDeviceSelectorController';

var cellularDeviceModule = angular.module('app.areas.common.cellularDeviceSelector', [
]);

cellularDeviceModule
    .component(CellularDeviceSelectorComponent.$name, new CellularDeviceSelectorComponent())
    .controller(CellularDeviceSelectorController.$name, CellularDeviceSelectorController);

export default cellularDeviceModule.name;
